import React from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ExternalLink, Calendar } from "lucide-react";

export default function LiveLesson({ lesson, onCompleted }) {
  const p = lesson.payload;
  const starts = p.starts_at ? new Date(p.starts_at) : null;
  const now = new Date();
  const isFuture = starts && starts > now;

  const downloadIcs = async () => {
    try {
      const res = await api.get(`/alumno/live-sessions/${lesson.id}/ics`, { responseType: "blob" });
      const blob = new Blob([res.data], { type: "text/calendar" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `dcc-${lesson.id}.ics`;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
      toast.success("Calendario descargado");
    } catch { toast.error("No se pudo descargar"); }
  };

  return (
    <div data-testid="lesson-live" className="space-y-4">
      <div className="p-6 rounded-lg border border-gray-800 bg-gradient-to-br from-[#0F172A] to-[#111827]">
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Sesión en vivo</p>
        <p className="mt-2 text-2xl font-bold text-white font-display">{lesson.title}</p>
        <div className="mt-4 grid sm:grid-cols-2 gap-3">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-gray-500">Fecha y hora</p>
            <p className="mt-1 text-white font-mono">{starts ? starts.toLocaleString("es-MX") : "Por confirmar"}</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-widest text-gray-500">Duración</p>
            <p className="mt-1 text-white">{p.duration_min || 60} minutos</p>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <a
            href={p.zoom_url || "#"}
            target="_blank"
            rel="noreferrer"
            data-testid="live-zoom-btn"
            aria-label="Unirme por Zoom"
            className="inline-flex items-center gap-2 px-5 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm font-semibold"
          >
            <ExternalLink className="w-4 h-4" aria-hidden="true" /> Unirme por Zoom
          </a>
          <button
            onClick={downloadIcs}
            data-testid="live-ics-btn"
            aria-label="Agregar a calendario"
            className="inline-flex items-center gap-2 px-5 py-2 rounded-md border border-gray-700 text-gray-100 hover:bg-white/5 text-sm font-semibold"
          >
            <Calendar className="w-4 h-4" aria-hidden="true" /> Agregar a calendario (.ics)
          </button>
        </div>
        {isFuture && (
          <p className="mt-3 text-xs text-amber-300">
            La sesión aún no ha comenzado. Podrás marcarla como completada después de la fecha programada.
          </p>
        )}
      </div>
      <div className="flex items-center justify-end">
        <button
          onClick={onCompleted}
          disabled={isFuture && lesson.status !== "completed"}
          data-testid="lesson-complete-btn"
          aria-label="Marcar sesión como completada"
          className="px-5 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm font-semibold disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Marcar como completada
        </button>
      </div>
    </div>
  );
}
